var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`kpt-restricted-content ${_vm.type}`},[_c('div',{class:`kpt-restricted-content-label ${_vm.position}`},[_vm._v(_vm._s(_vm.label))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }